module.exports = __webpack_public_path__ + "static/media/video-play-file.339f2d7a.svg";